module.exports = __webpack_public_path__ + "img/edge_activites_port.79002545.svg";